module.exports = __webpack_public_path__ + "img/client-5--small.png?874d8c4f07708f57bbde240d6d24c7e6";